/* ============================================================
   NORTHSHEEP — rotating offer banner on collection pages
   (snippets/ns-promo-rotator.liquid; owner, 8 Oct 2026)

   Slides [data-ns-slide] inside [data-ns-rot]; one shows at a time
   (.is-active), the others fade out and leave the tab order (inert).
   The dots under the banner show which one and pick one; the timer
   steps every data-ns-rot-secs seconds and starts over after a pick.
   It waits while the banner is off screen or a control in it has
   focus. Owner, 8 Oct 2026: "i dont see it changing automatically" -
   it no longer pauses under the mouse, and reduced motion only drops
   the fade (CSS), not the turning.

   The grid is re-rendered by sorting and filtering, which replaces the
   banner without running this file again: new banners are picked up
   by an observer on the grid's container, and each banner is set up
   once (data-ns-rot-ready).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsPromoRotator) return;
  window.__nsPromoRotator = true;

  function setup(root) {
    if (root.hasAttribute('data-ns-rot-ready')) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ns-slide]'));
    if (slides.length < 2) return;
    root.setAttribute('data-ns-rot-ready', '');
    // ONE row of dots, outside every link (owner, 8 Oct 2026: "when i click a
    // dot to see next i just click on the collection" - inside a slide they
    // sat in the offer's own link). Placed under the words of the offer on
    // show, left with the text, a little below the last line.
    var row = root.querySelector('[data-ns-rot-dots]');
    // NOTHING JUMPS WHEN AN OFFER TURNS (owner, 8 Oct 2026: "maybe the text
    // have to fit a certain block because now the image and dots and text
    // jumps on every change as one text is longer then the other"): the words
    // column takes the width of the widest offer (--ns-rot-text-w, read by
    // ns-collection-promos.css). The dots are a row centred under the whole
    // block ("dont you think these dots ... should live under the whole
    // block"), outside every link, laid out by the CSS alone.
    function visibleKids(body) {
      return Array.prototype.filter.call(body.children, function (c) {
        return !c.matches('[data-ns-rot-dots]') && c.getBoundingClientRect().width > 0;
      });
    }
    // The width of the longest LINE the words actually take, not the width of
    // the box around them: on a phone the column is wider than its text, and
    // only the text's own width lets the photo and words centre as one block
    // (owner, 8 Oct 2026: "can you center the block on mobile too?").
    function textWidth(body) {
      var w = 0;
      visibleKids(body).forEach(function (c) {
        var rg = document.createRange();
        rg.selectNodeContents(c);
        w = Math.max(w, rg.getBoundingClientRect().width);
      });
      var cs = getComputedStyle(body);
      return w + (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    }
    function measure() {
      root.style.removeProperty('--ns-rot-text-w');
      var w = 0;
      slides.forEach(function (s) {
        var body = s.querySelector('.ns-promo__body');
        if (body) w = Math.max(w, textWidth(body));
      });
      if (w > 0) root.style.setProperty('--ns-rot-text-w', Math.ceil(w + 2) + 'px');
    }
    function settle() {
      measure();
    }
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ns-rot-dot]'));
    var i = 0;
    var secs = Math.max(3, parseFloat(root.getAttribute('data-ns-rot-secs')) || 6);
    var timer = null;
    var focus = false;
    var seen = true;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
      });
      dots.forEach(function (d) {
        var on = parseInt(d.getAttribute('data-ns-rot-dot'), 10) === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    function plan() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!focus && seen) show(i + 1);
        plan();
      }, secs * 1000);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(parseInt(d.getAttribute('data-ns-rot-dot'), 10) || 0);
        plan();
      });
    });
    window.addEventListener('resize', function () {
      clearTimeout(root.__nsRotPlace);
      root.__nsRotPlace = setTimeout(settle, 120);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
    window.addEventListener('load', settle);
    root.addEventListener('focusin', function (e) { if (!e.target.closest('[data-ns-rot-dot]')) focus = true; });
    root.addEventListener('focusout', function () { focus = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
    }
    show(0);
    root.classList.add('is-ready');
    settle();
    plan();
    // The other offers' photos are lazy and hidden, so they would only start
    // loading when their turn came (an empty box for a moment). Once the page
    // has loaded, fetch them in the background.
    function warm() {
      slides.forEach(function (s) {
        Array.prototype.forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
      });
    }
    if (document.readyState === 'complete') setTimeout(warm, 600);
    else window.addEventListener('load', function () { setTimeout(warm, 600); });
  }

  /* THE SECRET POCKET (ns-collection-promos.css), phones only, for any banner
     marked data-ns-pocket (the rotating one, or a page's single offer): it is
     pulled out from under the hides as the page scrolls over it, top first.
     The browser runs it as an animation tied to the scroll position, so it is
     as smooth as the scrolling itself (owner, 8 Oct 2026: "i want it to be
     extremly smooth and fluent"); this only measures where it happens, once
     and again when the page's size changes, never while scrolling.
     Until it starts, the shopper sees a row of hides right under the row
     above (owner: "so that you first saw the cowhides on top of it"); it is
     done while the banner sits high, so the next row shows under it (owner:
     "not all the way at the bottom otherwise you still dont see the next row
     of cowhides"); how fast: see measure(). A browser without scroll-linked
     animations gets the banner standing open. */
  function pocket(root) {
    var grid = root.parentElement;
    if (!grid || !root.nextElementSibling) return;
    if (!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()') && CSS.supports('animation-range: 1px 2px'))) return;
    var timer = null;
    // ONCE OPEN, IT STAYS OPEN (owner, 8 Oct 2026: "when you scroll back up the
    // promotion closes again but wouldnt you juset keep it open ... because
    // maybe they want to scroll back up to read or look at the promotion"):
    // the first time the page reaches the fully-open point the pocket is
    // switched off for the rest of the visit, so going back up shows the
    // banner where it is. Fully open, the hides already stand in their own
    // place, so switching off changes nothing on screen. Turning back before
    // that still folds it away (frozen half-covered would look broken).
    var done = false;
    var openAt = Infinity;
    function finish() {
      done = true;
      grid.classList.remove('ns-pocket-on');
      window.removeEventListener('scroll', check);
    }
    // One comparison per scroll, nothing measured or moved.
    function check() {
      if ((window.scrollY || window.pageYOffset) >= openAt - 1) finish();
    }
    // Where the banner sits on the page. Not getBoundingClientRect: the
    // animation moves its box, offsetTop does not see that.
    function pageTop(el) {
      var y = 0;
      for (; el; el = el.offsetParent) y += el.offsetTop;
      return y;
    }
    function measure() {
      if (!root.isConnected) {
        window.removeEventListener('resize', later);
        window.removeEventListener('scroll', check);
        return;
      }
      if (done) return;
      // The visible screen height without the browser's own bars, which
      // does not change while the address bar folds away on a phone.
      var vh = document.documentElement.clientHeight || window.innerHeight;
      var gcs = getComputedStyle(grid);
      var gap = parseFloat(gcs.rowGap) || 0;
      var total = root.offsetHeight + gap;
      // A LITTLE SLOWER THAN THE SCROLLING (owner, 8 Oct 2026: "i feel like it
      // opens extremly quick can it be a bit slower? like maybe just bit slower
      // then page scroll speed but still together with page scroll"): it opens
      // over a third more scroll than its own height, so on average about three
      // quarters of the scroll speed and at most about 0.9 with the soft curve
      // in the CSS; the hides under it keep rising slowly, never pushed down.
      // Fully open with its top just under the header (the next row then shows
      // under it); to make room for the slower opening it starts low, once its
      // spot is in the bottom part of the screen, and the next row stays in
      // view under it all the way.
      var end = Math.max(vh * 0.1, 64);
      var start = Math.min(vh * 0.95, end + total * 1.33);
      var top = pageTop(root);
      grid.style.setProperty('--ns-pk-h', total.toFixed(1) + 'px');
      // The gaps the page-coloured sheet behind each sliding hide reaches over.
      grid.style.setProperty('--ns-pk-row', gap + 'px');
      grid.style.setProperty('--ns-pk-col', (parseFloat(gcs.columnGap) || 0) + 'px');
      grid.style.setProperty('--ns-pk-a', Math.max(0, top - start).toFixed(1) + 'px');
      grid.style.setProperty('--ns-pk-b', Math.max(1, top - end).toFixed(1) + 'px');
      openAt = Math.max(1, top - end);
      grid.classList.add('ns-pocket-on');
      check();
    }
    function later() {
      clearTimeout(timer);
      timer = setTimeout(measure, 120);
    }
    measure();
    if (!done) window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', later, { passive: true });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    // Photos and fonts above it settling change where it sits.
    if ('ResizeObserver' in window) new ResizeObserver(later).observe(grid);
  }

  function scan() {
    var all = document.querySelectorAll('[data-ns-rot]:not([data-ns-rot-ready])');
    for (var k = 0; k < all.length; k++) setup(all[k]);
    // The pocket, for the rotating banner and for a single offer banner alike
    // (owner, 8 Oct 2026: "so sheepskins too").
    var pk = document.querySelectorAll('[data-ns-pocket]:not([data-ns-pocket-ready])');
    for (var m = 0; m < pk.length; m++) {
      pk[m].setAttribute('data-ns-pocket-ready', '');
      pocket(pk[m]);
    }
  }

  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  var box = document.getElementById('ProductGridContainer') || document.querySelector('main') || document.body;
  if ('MutationObserver' in window && box) {
    new MutationObserver(function () { scan(); }).observe(box, { childList: true, subtree: true });
  }
})();
